'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Letter = function (_React$PureComponent) {
  _inherits(Letter, _React$PureComponent);

  function Letter() {
    _classCallCheck(this, Letter);

    return _possibleConstructorReturn(this, (Letter.__proto__ || Object.getPrototypeOf(Letter)).apply(this, arguments));
  }

  _createClass(Letter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          color = _props.color,
          label = _props.label,
          children = _props.children;

      return _react2.default.createElement(
        'div',
        {
          className: _style2.default.dynamic([['1993167178', [color, color]]]) + ' ' + 'holder'
        },
        _react2.default.createElement(
          'div',
          {
            className: _style2.default.dynamic([['1993167178', [color, color]]]) + ' ' + ('selected-option ' + size)
          },
          label
        ),
        children && _react2.default.createElement(
          'div',
          {
            className: _style2.default.dynamic([['1993167178', [color, color]]]) + ' ' + 'content'
          },
          children
        ),
        _react2.default.createElement(
          _style2.default,
          {
            id: '1993167178',
            dynamic: [color, color]
          },
          ['.holder.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}', '.content.__jsx-style-dynamic-selector{width:90%;}', '.selected-option.__jsx-style-dynamic-selector{margin-right:3%;border:4px solid ' + color + ';border-radius:50%;font-family:\'Open Sans\',sans-serif;font-weight:bold;color:' + color + ';-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;text-transform:uppercase;}', '.small.__jsx-style-dynamic-selector{width:45px;height:45px;font-size:20px;}', '.medium.__jsx-style-dynamic-selector{width:55px;height:55px;font-size:25px;}', '.large.__jsx-style-dynamic-selector{width:65px;height:65px;font-size:30px;}']
        )
      );
    }
  }]);

  return Letter;
}(_react2.default.PureComponent);

Letter.propTypes = {
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  color: _propTypes2.default.string,
  label: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node
};

Letter.defaultProps = {
  size: 'large',
  color: '#AEAEAE',
  children: null
};

exports.default = Letter;